module.exports = __webpack_public_path__ + "static/media/bod.d1cf9569.svg";